module.exports = __webpack_public_path__ + "Flag-694.999c33d4a34093fcbc3f4df459f40263.svg";